/* global $ */
import { createElement, Component, PropTypes } from 'rlink-react';
import themeable from 'rlink-theme/themeable';

import studioScene from 'helpers/scenes/studioScene';
import Picture from 'rlink-repos/components/Picture';

const sliderSettings = {
  autoplay: false,
  autoplaySpeed: 4000,
  arrows: false,
  dots: true,
  respondTo: '#slider',
};

export default class StudioSection extends Component {
  componentDidMount () {
    $('#StudioSlider').slick(sliderSettings);
    $(window).on('slider-start', () => {
      $('#StudioSlider').slick('slickPlay');
    });
    $(window).on('slider-stop', () => {
      $('#StudioSlider').slick('slickPause');
    });
    studioScene();
  }

  render () {
    let {theme, studioSliderData} = this.props;
    return (
      <div>
        <article id="studio" className="layout-text bg-white text-black clearfix">
          <div className="wrapper">
            <div className="row">
              <h2>The Studio</h2>
              <div>
                <p>We are an award-winning developer of genre-defining games like Homeworld, Dawn of War, Company of Heroes, and Age of Empires. We have delivered rich, thoughtful strategy games throughout our history and our vision is to continue making games that people love to play.</p>
                <p>We have a culture of kindness, transparency, and play. There is a lot of heart and passion at this studio – we get to work on projects we’re proud of and we work hard to be the best at what we do. We are curious, we strive for excellence, we build on each other’s ideas, and we celebrate each other’s great work. Relicans organize movie nights, game tournaments, life drawing, community and charity events, and more. Basically, we believe that good work starts with a community you’re excited to spend your day with, both in and out of the studio.</p>
                <p>We love creating and playing games. We value ideas and innovation so every title we deliver is a reflection of our entire teams’ talents and passions. Being part of the SEGA family gives us access to the resources to enable us to build on our legacy of innovation. We have the best of two worlds: the autonomous, entrepreneurial spirit and talent of an indie developer combined with the extensive reach of a large publisher. The story of Relic is ours to create.</p>
              </div>
            </div>
          </div>
        </article>
        <article id="slider" className="layout-text bg-white clearfix">
          <p />
          <div className="wrapper">
            <div className="row">
              <div id="StudioSlider" className={`slider ${theme.StudioSlider}`}>
                {studioSliderData
                  .sort((a, b) => Number.parseInt(a.priority) - Number.parseInt(b.priority))
                  .map(item => (
                    item.mainImageFormats.src !== '' && (
                      <div key={`studioSlider-${item.mainImageFormats.src}`}>
                        <Picture
                          src={item.mainImageFormats.src}
                          widths={item.mainImageFormats.widths}
                          heights={item.mainImageFormats.heights}
                          formats={item.mainImageFormats.formats} />
                      </div>
                    )
                  ))}
              </div>
            </div>
          </div>
        </article>
      </div>
    );
  }
}

StudioSection.propTypes = {
  studioSliderData: PropTypes.arrayOf(PropTypes.shape({
    mainImageFormats: PropTypes.shape({
      src: PropTypes.string,
      widths: PropTypes.arrayOf(PropTypes.number),
      heights: PropTypes.arrayOf(PropTypes.number),
      formats: PropTypes.arrayOf(PropTypes.shape({
        contentType: PropTypes.string,
        fileExt: PropTypes.string,
      })),
    }),
    title: PropTypes.string,
    priority: PropTypes.number,
  })),
};

themeable(StudioSection, {
  classes: [
    'StudioSlider',
  ],
});



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/AboutUs/StudioSection.jsx